import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';

export const EditCustomerNamePaneContainer = styled.div`
  .inflight-invoice-banner {
    margin-top: ${token('space.100', '8px')};
  }
`;
